export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center pt-20"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.97) 50%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.6) 100%), url('https://public.readdy.ai/ai/img_res/48bbd645ae9f1b58de8ffcf0cb4b0fdf.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full mb-6">
            <i className="ri-leaf-line"></i>
            <span className="text-sm font-semibold">Circular Infrastructure Pioneer</span>
          </div>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Transforming Wastewater into <span className="text-emerald-600">Clean Energy, Fertiliser, and Water</span>
          </h1>
          
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            Kagesi Development converts industrial wastewater, cluster housing wastewater, and municipal sewage into clean energy, climate-smart fertilisers, and reclaimed water—creating sustainable solutions for cities, industries, and communities across Africa.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button onClick={scrollToContact} className="bg-emerald-600 text-white px-8 py-4 rounded-lg hover:bg-emerald-700 transition-all font-semibold text-lg shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Partner With Us
            </button>
            <button onClick={() => document.getElementById('solutions')?.scrollIntoView({ behavior: 'smooth' })} className="bg-white text-gray-900 px-8 py-4 rounded-lg hover:bg-gray-50 transition-all font-semibold text-lg border-2 border-gray-200 whitespace-nowrap cursor-pointer">
              Our Solutions
            </button>
          </div>

          <div className="grid grid-cols-3 gap-8 mt-16 pt-8 border-t border-gray-200">
            <div>
              <div className="text-3xl font-bold text-emerald-600 mb-1">4</div>
              <div className="text-sm text-gray-600">Core Platforms</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-600 mb-1">SADC</div>
              <div className="text-sm text-gray-600">Regional Coverage</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-emerald-600 mb-1">2024</div>
              <div className="text-sm text-gray-600">Founded in Zimbabwe</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}